import React from 'react';

import Select from "react-select";

import './index.css';
import PPDropDownProps from './PPDropDownProps';
import Async, { useAsync } from 'react-select/async';
import AsyncSelect from 'react-select/async';

const customStyles = (width, isRequired) => ({
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#FFB800' : '#EBEBEB',
        boxShadow: state.isFocused ? '0px 0px 18px 0px rgba(58, 79, 135, 0.2)' : null,
        borderLeft: isRequired ? '3px solid #ffb800' : null,
        width: width,
    }),
});

const PPDropDown = ({ options, title, name, defaultValue, width, style, required, disabled, isMulti, handleMenuOpen, ...otherProps }: PPDropDownProps) => {
    const promiseOptions = (inputValue: string) =>
        new Promise<any[]>((resolve) => {
            setTimeout(() => {
                handleMenuOpen && resolve(handleMenuOpen(inputValue));
            }, 1000);
        });
    return <div className="ppdropdown" style={style}>
        {title && <label htmlFor={name}>{title}</label>}

        <AsyncSelect
            className="ppdropdown-container"
            classNamePrefix="ppdropdown" 
            //isClearable={true}
            cacheOptions
            defaultOptions={options}
            loadOptions={promiseOptions} 
            inputId={name}
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    neutral5: "#cccccf",
                    neutral20: "#ccc",
                    neutral30: "#9196A7",
                    neutral80: "#141B4D",
                    neutral90: "#2B304F",
                    primary25: "#ebebeb",
                    primary50: "#eeeeee",
                    primary: "#ccc"
                }
            })}
            placeholder="Selecione..."
            styles={customStyles(width, required)}
            isDisabled={disabled ?? false}
            noOptionsMessage={({ inputValue }) => !inputValue ? inputValue : "Sem resultados"}

            isMulti={isMulti}
            {...otherProps}
        />
    </div>
}

export default PPDropDown;